import * as React from "react";
import { NavLink } from "react-router-dom";
import { MUIDataTableMeta } from "mui-datatables";
import * as Dati from "src/Dati";
import * as Glob from "src/Globale";
import { Trad } from "src/components";
import { _ButtonAPI, _GeneratedPolicyLink } from "../../components";

const calculateCommission = (premiumJSON: string): number => {
    const premium = JSON.parse(premiumJSON);

    return [].concat.apply([], premium).reduce((total: any, item: any) => total + item.ValoreProvvigione, 0);
};

export const GetReceiptsListColumns = (onClickCashOut: (data: Dati.CRisAPI) => void, onApiError: (error: Error) => void) => [
    {
        name: "ID_Quietanza",
        label: Trad.Trad("Quietanza"),
        options: {
            filter: false
        }
    },
    {
        name: "Polizza",
        label: Trad.Trad("Polizza"),
        options: {
            filter: false,
            customBodyRender: (val: string, tableMeta: MUIDataTableMeta) => {
                const rowData = { ...new Dati.CQuietanza(), ...tableMeta.tableData[tableMeta.rowIndex] };

                return (
                    <_GeneratedPolicyLink Id={rowData.ID_Polizza.toString()} Type={Glob.Tipi_DT_Polizza}>
                        {val}
                    </_GeneratedPolicyLink>
                );
            }
        }
    },
    {
        name: "TipoQuietanza",
        label: Trad.Trad("Tipo"),
        options: {
            filter: false
        }
    },
    {
        name: "Progressivo",
        label: Trad.Trad("Progressivo"),
        options: {
            filter: false
        }
    },
    {
        name: "TipoQuietanzaStato",
        label: Trad.Trad("Stato"),
        options: {
            filter: false
        }
    },
    {
        name: "DataInizioCopertura",
        label: Trad.Trad("InizioCopertura"),
        options: {
            filter: false,
            customBodyRender: (val: Date) => Trad.Trad(val)
        }
    },
    {
        name: "DataFineCopertura",
        label: Trad.Trad("FineCopertura"),
        options: {
            filter: false,
            customBodyRender: (val: Date) => Trad.Trad(val)
        }
    },
    {
        name: "PremioJSON",
        label: Trad.Trad("Premio"),
        options: {
            filter: false,
            sort: false,
            setCellProps: () => ({
                align: "right"
            }),
            customBodyRender: (val: string) => Trad.TradParam("{1-I}", [calculateCommission(val)])
        }
    },
    {
        name: "ID_Quietanza",
        label: Trad.Trad("Azioni"),
        options: {
            filter: false,
            sort: false,
            setCellHeaderProps: () => ({
                align: "center"
            }),
            setCellProps: () => ({
                align: "center"
            }),
            customBodyRender: (val: string, tableMeta: MUIDataTableMeta) => {
                const rowData = { ...new Dati.CQuietanza(), ...tableMeta.tableData[tableMeta.rowIndex] };

                return (
                    Glob.AzioneAbilitata("QuietanzaController", Glob.Scrittura) &&
                    rowData.ID_TipoQuietanzaStato === Glob.Tipi_QS_Emessa && (
                        <_ButtonAPI URL={`/api/Quietanza/Incassa?ID_Quietanza=${val}`} Testo={Trad.Trad("Incassa")} OnClick={onClickCashOut} OnErrore={onApiError} size="small" />
                    )
                );
            }
        }
    }
];



// WEBPACK FOOTER //
// ./src/inar2/components/SearchTableColumns/ReceiptsListColumns.tsx